export default __webpack_public_path__ + "static/media/training_icon2.5cb293cd.svg";